import { Typography } from '@mui/material';
import { useFieldHelper } from 'framework/ui/field';

interface AssignmentPendingIndicatorProps {
  source: string;
}

const AssignmentPendingIndicator = ({ source }: AssignmentPendingIndicatorProps) => {
  const { getValue } = useFieldHelper<boolean>({ source });

  if (!getValue()) {
    return null;
  }

  return (
    <Typography variant="body1" color="error">
      Assign is Pending
    </Typography>
  );
};

export default AssignmentPendingIndicator;
